// src/composables/useDailyStreakEngine.js

import { useProgressStore } from "@/stores/progressStore";

function todayKey() {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD
}

function yesterdayKey() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return d.toISOString().slice(0, 10);
}

export function useDailyStreakEngine() {
  const progressStore = useProgressStore();

  function ensure(childId) {
    if (!progressStore.dailyStreak) {
      progressStore.dailyStreak = {};
    }

    if (!progressStore.dailyStreak[childId]) {
      progressStore.dailyStreak[childId] = {
        count: 0,
        lastActiveDate: null
      };
    }

    return progressStore.dailyStreak[childId];
  }

  /**
   * Call this ONCE per meaningful activity:
   * - lesson completion
   * - revision completion
   * - test completion
   */
  function registerActivity(childId) {
    const s = ensure(childId);

    const today = todayKey();
    const yesterday = yesterdayKey();

    if (s.lastActiveDate === today) {
      // already counted today
      return;
    }

    if (s.lastActiveDate === yesterday) {
      s.count += 1;
    } else {
      s.count = 1; // reset streak
    }

    s.lastActiveDate = today;
  }

  function getStreak(childId) {
    const s = ensure(childId);
    return {
      count: s.count || 0,
      isActiveToday: s.lastActiveDate === todayKey()
    };
  }

  return {
    registerActivity,
    getStreak
  };
}
